import { contentDelete, contentGet, contentPatch, contentPost, contentPut } from '../../../../shared/email-activity/content-api'

// An organization's API keys (Phase D): content's /api/ddd routes (plan
// Task 12), and their usage and request-log reads (Task 14). Each resolves
// to the body; a refusal throws the response ({ status, data: { code,
// message } }), so serverMessage(err) shows the server's own sentence.
//
// The secret of a create or rotate ({ key, secret }) is handed straight to
// the caller and kept nowhere here.

// { enabled, default_rate_limit_per_minute, live_keys, max_keys }
export const getAccess = () => contentGet('api-access')
// [KeyView], newest first. With a binding ({ kind, id }; Phase D D7-8),
// only the keys bound to that record: an LMS connection's drawer lists its
// keys so.
export const listKeys = binding =>
  binding ? contentGet('api-key', { binding_kind: binding.kind, binding_id: binding.id }) : contentGet('api-key')
// The API roles this person may give a key: [{ id, name, description }]
export const listRoles = () => contentGet('api-key/roles')
// The resource groups a key can be given per resource here (spec 2026-10-20
// §10; contract §4.7), EducationXR staff only (403 api_key.grants_staff_only
// for anyone else): content's { groups } as the list, [{ id, label,
// description, levels, platform_only }]. AI tools telemetry is listed only
// on EducationXR's own organization.
export const listResources = async () => {
  const body = await contentGet('api-key/resources')
  return body && Array.isArray(body.groups) ? body.groups : []
}
export const getKey = id => contentGet(`api-key/${id}`)
// A preset: { name, description, role_id, expires_at, system_key? }; custom
// permissions (staff only): { name, description, expires_at, grants }.
// -> { key, secret } (system_key, Phase E: optional, and fixed for the
// key's life)
export const createKey = body => contentPost('api-key', body)
// { name?, description?, role_id? } -> KeyView
export const updateKey = (id, body) => contentPatch(`api-key/${id}`, body)
// A key's permissions per resource, { groupID: 'read' | 'read_write' } (the
// groups above No access), staff only -> KeyView. A preset key becomes a
// custom one.
export const updateGrants = (id, grants) => contentPut(`api-key/${id}/grants`, { grants })
// grace_hours (0, 1, 24 or 168) is required -> { key, secret }
export const rotateKey = (id, graceHours) => contentPost(`api-key/${id}/rotate`, { grace_hours: graceHours })
// An optional reason (at most 500 characters).
export const revokeKey = (id, reason) => {
  const text = String(reason || '').trim()
  return contentDelete(`api-key/${id}`, undefined, text ? { reason: text } : {})
}

// Task 14: a key's usage by the hour (UTC hours; the page sums them into
// the viewer's days), its request log page by page (?cursor= is the last
// page's `next`), and one request.
export const getKeyUsage = (id, { from, to }) => contentGet(`api-key/${id}/usage`, { from, to, group: 'hour' })
export const listKeyRequests = (id, params) => contentGet(`api-key/${id}/requests`, params)
export const getKeyRequest = (id, requestLogID) => contentGet(`api-key/${id}/requests/${encodeURIComponent(requestLogID)}`)
